import { oqulyqtarApi } from "../api";

const userViewApi = oqulyqtarApi.injectEndpoints({
  endpoints: (build) => ({
    getUserView: build.query({
      query: (payload) => ({
        url: "/user/view",
        method: "GET",
        params: payload,
      }),
      providesTags: (result = [], error, arg) => [
        { type: "UserInfo", id: result.user?.username },
      ],
    }),
    getUserViewByAdmin: build.query({
      query: (payload) => ({
        url: "/user/view-by-admin",
        method: "GET",
        params: payload,
      }),
    }),
  }),
});

export const { useLazyGetUserViewQuery, useLazyGetUserViewByAdminQuery } =
  userViewApi;
